import { format } from "date-fns";
import { ChatLeftText } from "react-bootstrap-icons";
import { Modal } from "@components";
import TaggedUsers from "@components/TaggedUsers";

// The note's own timestamp, in the calendar detail modal's "created" style so the two read alike.
const formatCreated = (iso) => {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return format(date, "EEEE, dd MMMM yyyy 'at' HH:mm");
};

/**
 * Read-only view of a note from the AI Activity feed, built from the activity row itself (the feed
 * already carries the full note body, tagged colleagues, customer and author). Laid out like the
 * calendar's task detail — identity box, then the content — so the rail's modals feel like one set.
 */
const NoteDetailModal = ({ activity, isOpen, onClose, elevated = false }) => {
  if (!activity) return null;

  // The feed clips a long note into its displayText; the body is the full text when present.
  const body = activity.body ?? activity.title ?? activity.displayText ?? "";
  const author = activity.actorName ?? activity.actorLabel ?? null;
  const createdLine = [formatCreated(activity.occurredAt) && `Created ${formatCreated(activity.occurredAt)}`, author]
    .filter(Boolean)
    .join(" · ");

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Note" titleClassName="text-xl" size="md" elevated={elevated}>
      <div className="space-y-4 p-5">
        <div className="flex items-center gap-3.5 rounded-2xl border border-zinc-200 p-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-md bg-zinc-100 text-zinc-500">
            <ChatLeftText className="size-5" />
          </div>
          <div className="min-w-0 flex-1 space-y-1">
            <p className="text-sm font-semibold text-zinc-900">
              {activity.customerLabel || "Note"}
            </p>
            {createdLine && <p className="text-xs text-zinc-400">{createdLine}</p>}
          </div>
        </div>

        <div className="border-t border-zinc-100 pt-4">
          <h4 className="mb-1.5 text-xs font-medium uppercase tracking-wide text-zinc-400">Note</h4>
          <p className="whitespace-pre-wrap text-sm text-zinc-600">{body}</p>
          <TaggedUsers users={activity.taggedUsers} max={10} />
        </div>
      </div>
    </Modal>
  );
};

export default NoteDetailModal;
